import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white/90 backdrop-blur-md border-b border-brand-border py-2' : 'bg-transparent py-4'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex justify-between items-center">
        <a href="#" className="block group">
          <img 
            src="https://media-manager-c.questera.ai/greta-media/ab03ff55dc7bcdd9e4a34a93308a2aa656b3e0baf34844f0be8f244dd21175025656600d9573a40a26a1591403a49a1d/images/aW1hZ2UvanBlZw==/4a5835b64db5a106236ab96fc7aa3e94.jpeg" 
            alt="White Knight Global Consulting" 
            className="h-14 md:h-16 object-contain mix-blend-multiply transition-transform duration-300 group-hover:scale-105"
          />
        </a>
        <div className="hidden md:flex items-center gap-8 text-sm font-semibold tracking-wide">
          <a href="#about" className="text-brand-muted hover:text-brand-black transition-colors">About</a>
          <a href="#founder" className="text-brand-muted hover:text-brand-black transition-colors">Leadership</a>
          <a href="#services" className="text-brand-muted hover:text-brand-black transition-colors">Services</a>
          <a href="#cases" className="text-brand-muted hover:text-brand-black transition-colors">Cases</a>
          <a href="#contact" className="text-brand-gold hover:text-brand-black transition-colors">Inquire</a>
        </div>
      </div>
    </motion.nav>
  );
};

export default Navbar;